// extracted by mini-css-extract-plugin
module.exports = {"container":"adminList_container__2zuRB","disableMargin":"adminList_disableMargin__1lEEC","list":"adminList_list__2sGZ-"};